import { Button } from 'blaze-ui/Button'
import { Font, TextStyle } from 'types'
import { Modal, StackModalProps } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { FONT_ROLES_LABELS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'

export interface FontInUseModalProps extends StackModalProps {
  onClose: () => void
  onPressOutside: () => void
  font: Font
  usedByTextStyles: TextStyle[]
}

export const FontInUseModal = ({ onClose, onPressOutside, font, usedByTextStyles }: FontInUseModalProps) => {
  const roleLabels = [
    ...new Set(
      usedByTextStyles.map((ts) => (FONT_ROLES_LABELS as Record<string, string>)[ts.font_role] ?? ts.font_role),
    ),
  ]
  const rolesText = roleLabels.join(' and ')

  return (
    <Modal.Root onPressOutside={onPressOutside}>
      <Modal.Header title="Font in use" />
      <Modal.Content>
        <Text>
          <strong>{font.name}</strong> is currently set as your <strong>{rolesText}</strong> font. To delete it, first
          change your {rolesText} font to a different font in your brand style settings, then try deleting again.
        </Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Button onPress={onClose} size="lg" variant="primary">
            Got it
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
